import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Sparkles } from 'lucide-react';

function LandingPage() {
  const navigate = useNavigate();

  const BrainWithAtomic = () => (
    <div className="relative inline-block">
      {/* Base Brain icon */}
      <Brain size={64} className="text-blue-600" />
      
      {/* Atomic clock overlay */}
      <svg 
        viewBox="0 0 24 24" 
        className="absolute inset-0 w-full h-full pointer-events-none"
      >
        {/* Cesium atom center */}
        <circle 
          cx="12" 
          cy="12" 
          r="1.5" 
          fill="#4338ca" 
          className="animate-pulse"
        />
        
        {/* Electron orbits */}
        <ellipse
          cx="12"
          cy="12"
          rx="4"
          ry="2.5"
          fill="none"
          stroke="#818cf8"
          strokeWidth="0.5"
          className="opacity-60"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 12 12"
            to="360 12 12"
            dur="3s"
            repeatCount="indefinite"
          />
        </ellipse>
        
        <ellipse
          cx="12"
          cy="12"
          rx="5.5"
          ry="3.5"
          fill="none"
          stroke="#818cf8"
          strokeWidth="1"
          className="opacity-80"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="60 12 12"
            to="420 12 12"
            dur="4s"
            repeatCount="indefinite"
          />
        </ellipse>
        
        {/* Electrons */}
        <circle r="0.6" fill="#6366f1">
          <animateMotion
            path="M0,0 A4,2.5 0 1,1 0,0.01"
            dur="3s"
            repeatCount="indefinite"
          />
        </circle>
        
        <circle r="0.6" fill="#6366f1">
          <animateMotion
            path="M0,0 A5.5,3.5 0 1,1 0,0.01"
            dur="4s"
            repeatCount="indefinite"
          />
        </circle>
        
        {/* Energy level indicators */}
        <line
          x1="8"
          y1="12"
          x2="16"
          y2="12"
          stroke="#a5b4fc"
          strokeWidth="0.3"
          strokeDasharray="0.5,0.5"
          className="opacity-40"
        >
          <animate
            attributeName="opacity"
            values="0.2;1;0.2"
            dur="2s"
            repeatCount="indefinite"
          />
        </line>
      </svg>
      
      {/* Sparkles overlay */}
      <Sparkles 
        size={32} 
        className="absolute -top-2 -right-2 text-yellow-400 animate-pulse" 
      />
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <BrainWithAtomic />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Research & Projects Platform
          </h1>
          <p className="text-xl text-gray-600">
            Explore My Projects
          </p>
        </div>

        {/* Main Options */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* BTD Research Paper Card */}
          <div 
            onClick={() => navigate('/btd')}
            className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-[1.02]"
          >
            <h2 className="text-2xl font-bold text-blue-800 mb-4">
              BTD Research Paper
            </h2>
            <p className="text-gray-600 mb-6">
              Explore our comprehensive research on Bidirectional Time Divergence 
              Theory and its applications.
            </p>
            <div className="text-blue-600 text-sm">
              Read more →
            </div>
          </div>

          {/* AI CRM Platform Card */}
          <div 
            onClick={() => navigate('/signin')}
            className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-[1.02]"
          >
            <h2 className="text-2xl font-bold text-blue-800 mb-4">
              AI CRM Platform
            </h2>
            <p className="text-gray-600 mb-6">
              Access our AI-powered CRM platform with BTD implementation.
            </p>
            <div className="text-blue-600 text-sm">
              Sign in →
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 text-gray-600">
          <p>Contact me at{" "}
            <a 
              href="https://www.linkedin.com/in/sumanth9427bb9b" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-600 hover:text-blue-800 hover:underline transition-colors"
            >
              LinkedIn @ www.linkedin.com/in/sumanth9427bb9b
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;